import * as SvgIcons from 'assets/svg/sprite'
import { type Orientation } from 'helpers/media'
import { FooterButton } from 'pages'
import { type ReelVideos, useUploadReelMedia } from 'services/reels'

interface UploadReelMediaProps {
  disabled?: boolean
  setImageData: (
    path: string,
    orientation: Orientation,
    exif_data: any,
    storage_path?: string,
    thumb_path?: string | null,
    id?: string
  ) => void
  setVideoData: (videos: ReelVideos) => void
  setProgressInfo: ((pct: number, cancelCb: () => void) => void) &
    ((reset: null) => void)
  clearMedia: () => void
  setMediaType: (mediaType: File | null) => void
  setThumbnail: (path: string) => void
  onTooManyFiles?: (count: number) => void
}

export const UploadReelMedia = ({
  disabled = false,
  setImageData,
  setVideoData,
  setProgressInfo,
  clearMedia,
  setMediaType,
  setThumbnail,
  onTooManyFiles
}: UploadReelMediaProps) => {
  const { handleMediaUploadClick, fileRef, handleSetUpload } =
    useUploadReelMedia({
      setImageData,
      setVideoData,
      setProgressInfo,
      clearMedia,
      setMediaType,
      setThumbnail,
      onTooManyFiles
    })

  const handleClick = () => {
    if (disabled) return
    handleMediaUploadClick()
  }

  return (
    <>
      <FooterButton
        icon={<SvgIcons.IconImageOutline color="white" />}
        type="black--transparent"
        clickFn={handleClick}
        disabled={disabled}
      />

      <input
        ref={fileRef}
        type="file"
        id="reel__media__upload"
        accept="image/*,video/mp4,video/x-m4v,video/*"
        hidden
        disabled={disabled}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault()
            e.stopPropagation()
            return
          }

          e.currentTarget.value = ''
        }}
        onChange={(e) => {
          if (disabled) return
          handleSetUpload(e)
        }}
      />
    </>
  )
}